import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_sales_order_multi_shipments_load_license_plates_grid_extendedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { order_id: number, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { locationName?: string, lookupCode?: string, packagedItemCount?: number, packagingName?: string, licensePlateId?: number, locationId?: number, status?: string, shipmentLookup?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id?: number, full_text_search?: string, $keys: number[] }): Promise<{ result?: { locationName?: string, lookupCode?: string, packagedItemCount?: number, packagingName?: string, licensePlateId?: number, locationId?: number, status?: string, shipmentLookup?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, full_text_search?: string    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
